document.addEventListener("DOMContentLoaded", function() {
  const description = document.querySelector(".truncated-description");
  const btn = document.querySelector(".read-more-btn");

  if (description.scrollHeight <= 100) {
    btn.style.display = "none";
  }

  btn.addEventListener("click", function() {
    if (description.classList.contains("expanded")) {
      description.classList.remove("expanded");
      btn.textContent = "Read more";
      btn.classList.remove('expanded');
    } else {
      description.classList.add("expanded");
      btn.textContent = "Read less";
      btn.classList.add('expanded');
    }
  });

  function checkAndAddReviewLink() {
    const reviewContainer = document.querySelector("#product_just_stars .SA__review_widget_item .SA__review_content.SA__overall");
  
    if (reviewContainer) {
      const hasTotalReviews = reviewContainer.querySelector(".SA__total_reviews");
      const hasRatingWrap = reviewContainer.querySelector(".SA__rating_wrap");
  
      if (!hasTotalReviews && !hasRatingWrap) {
        const reviewLink = document.createElement("span");
        reviewLink.className = "sa_empty_reviews";
        reviewLink.innerHTML = `<svg width="16" height="16" viewBox="0 0 50 50" fill="none" stroke="#0063F2" stroke-width="2" xmlns="http://www.w3.org/2000/svg">
                                  <polygon points="25,2 31,17 47,17 34,27 38,42 25,34 12,42 16,27 3,17 19,17"></polygon>
                                </svg>
                                <svg width="16" height="16" viewBox="0 0 50 50" fill="none" stroke="#0063F2" stroke-width="2" xmlns="http://www.w3.org/2000/svg">
                                  <polygon points="25,2 31,17 47,17 34,27 38,42 25,34 12,42 16,27 3,17 19,17"></polygon>
                                </svg>
                                <svg width="16" height="16" viewBox="0 0 50 50" fill="none" stroke="#0063F2" stroke-width="2" xmlns="http://www.w3.org/2000/svg">
                                  <polygon points="25,2 31,17 47,17 34,27 38,42 25,34 12,42 16,27 3,17 19,17"></polygon>
                                </svg>
                                <svg width="16" height="16" viewBox="0 0 50 50" fill="none" stroke="#0063F2" stroke-width="2" xmlns="http://www.w3.org/2000/svg">
                                  <polygon points="25,2 31,17 47,17 34,27 38,42 25,34 12,42 16,27 3,17 19,17"></polygon>
                                </svg>
                                <svg width="16" height="16" viewBox="0 0 50 50" fill="none" stroke="#0063F2" stroke-width="2" xmlns="http://www.w3.org/2000/svg">
                                  <polygon points="25,2 31,17 47,17 34,27 38,42 25,34 12,42 16,27 3,17 19,17"></polygon>
                                </svg>
                                <span> No reviews</span>
                                `
        reviewContainer.appendChild(reviewLink);
      }
      return true;
    }
    return false;
  }
  
  let attempts = 0;
  const maxAttempts = 15 * 2; 
  
  const interval = setInterval(() => {
    if (checkAndAddReviewLink() || attempts >= maxAttempts) {
      clearInterval(interval); 
    }
    attempts++;
  }, 500);
});